import { Component, Input, OnInit } from '@angular/core';
import { dropdownLink } from 'app/models/dropdownLink.interface';
import { SessionService } from 'app/services/session.service';
@Component({
    selector: 'account-dropdown',
    templateUrl: './account-dropdown.component.html',
    standalone: false
})
export class AccountDropdownComponent implements OnInit {
  @Input() headerText: string;
  @Input() apiSpecList: dropdownLink[];
  @Input() dropdownTo: dropdownLink[] = [
    {
      path: 'legacy/dashboard',
      title: 'Dashboard',
    },
    {
      path: 'legacy/dashboard/account',
      title: 'Account',
    },
    {
      path: 'account/logout',
      title: 'Sign out',
    },
  ];

  constructor(private sessionService: SessionService) {}

  ngOnInit(): void {
    if (this.apiSpecList && this.apiSpecList.length) {
      this.dropdownTo = this.apiSpecList;
    }
  }

  signOut() {
    this.sessionService.logout();
  }
}
